import { APP_BODY_FONT_SIZE_PX } from "@/shared/styles/typography";

/**
 * Validation copy under a field. Same face and size as a system alert message.
 * Line box matches the alert message so caption defaults (12px, 1.66, tracked)
 * do not make the sentence look larger.
 */
const fieldErrorTypeSx = {
  fontFamily: "var(--font-sans)",
  fontSize: `${APP_BODY_FONT_SIZE_PX}px`,
  lineHeight: "16px",
  letterSpacing: 0,
} as const;

/** Error copy under a field: alert face, bold weight. */
export const fieldErrorTextSx = {
  ...fieldErrorTypeSx,
  fontWeight: 700,
} as const;

/** Same face as {@link fieldErrorTextSx}. Kept so existing call sites stay bold. */
export const fieldErrorBoldTextSx = fieldErrorTextSx;

/**
 * Same type, without letting the sentence set a shrink-to-fit parent's width.
 * `width: 0` drops the line from the parent's intrinsic size; `min-width: 100%`
 * then fills the width the fields already established and wraps inside it.
 */
export const fieldErrorWrapSx = {
  ...fieldErrorTextSx,
  display: "block",
  width: 0,
  minWidth: "100%",
  whiteSpace: "normal",
  overflowWrap: "anywhere",
} as const;
